import classNames from 'classnames';
import React from 'react';
import styles from './styles.module.scss';

export interface IProps {
  title: string,
  Icon: React.FC<{ className?: string }>,
  metric: string | React.ReactNode,
  className?: string,
}

export const MetricListItem = (
  {
    title, metric, Icon, className,
  }: IProps,
) => (
  <div className={classNames(styles.box, className)}>
    <div className={classNames(styles.icon)}>
      <Icon />
    </div>
    <div className={classNames(styles.title)}>
      {title}
    </div>
    <div className={classNames(styles.metric)}>
      {metric}
    </div>
  </div>
);
